/* eslint-disable no-unused-vars */

export enum DoctorActivityStatusEnum {
  Offline = 0,
  Online = 1,
  Busy = 2,
}

export enum ServiceIdEnum {
  ondemandCall = 1,
  scheduledCall = 2,
  ondemandChat = 3,
  scheduledChat = 4,
  inPersonVisit = 5,
}

export const serviceIdEnum = {
  1: 'ondemandCall',
  2: 'scheduledCall',
  3: 'ondemandChat',
  4: 'scheduledChat',
  5: 'inPersonVisit',
};

export interface DoctorTarif {
  id: number;
  serviceId: number;
  specialityId: number;
  durationMinute: number;
  fee: number;
}

export interface DoctorService {
  id: number;
  title: string;
  description: string;
  fee: number;
  serviceType: number;
  tarifs: DoctorTarif[];
  isActive: boolean;
}

export interface DoctorProfile {
  rate: number;
  recId: number;
  fullName: string;
  imageUrl?: string;
  aboutDoctor: null;
  systemType: number;
  hasSchedule: boolean;
  medicalNumber: string;
  educationLevelId: number;
  latestSpecialityId: number;
  latestSpecialityName: string;
  doctorExperienceDate?: number;
  subLatestSpecialityId: number;
  cities: string[];
  profileId: number;
}

export type DoctorProfileResponse = {
  result: DoctorProfile;
};

export type DoctorProfileResponseModel = {
  isSuccess: boolean;
  message: string;
  resultCode: string;
  errors: string | null;
  data: DoctorProfileResponse;
};

export interface DoctorReview {
  comment: string;
  updatedAt: string;
  doctorId: number;
  id: number;
  rating: number;
  userPhoneNumber: string;
  rate: number;
  satisfactionTypeName: string[];
  dissatisfactionTypeName: string[];
}

export interface DoctorComment {
  id: number;
  bookingId: number;
  comment: string;
  createdAt: string;
  updatedAt: string;
  doctorId: number;
  rating: number;
  userPhoneNumber: string;
  satisfactionTypeName: string[];
  dissatisfactionTypeName: string | null;
}

export enum ConsultantTypeEnum {
  ONDEMANDCALL = 'OndemandCall',
  SCHEDULEDCALL = 'ScheduledCall',
  ONDEMANDCHAT = 'OndemandChat',
  RX = 'Rx',
}

export type DoctorDataModel = {
  activityStatus: DoctorActivityStatusEnum;
  subtitle: string;
  title: string;
  averageWait: number;
  doctorExperienceDate: string;
  fullName: string;
  gender: string;
  id: string;
  isInsurance: boolean;
  isTextEnabled: boolean;
  isVideoEnabled: boolean;
  isVoiceEnabled: boolean;
  latestSpecialityId: number;
  latestSpecialityName: string;
  licensedFrom: number;
  licensedTo: number;
  medicalNumber: number | null;
  modifiedAt: string;
  orderCount: number;
  originType: number;
  rate: number;
  rateCount: number;
  recId: number;
  showComment: boolean;
  status: number;
  imageUrl: string;
  doctorReviewsCount: number;
  hasInPersonCalendar: false;
  cities: string[];
};

export type GetDoctorListDataModel = {
  result: DoctorDataModel[];
  pageNumber: number;
  pageSize: number;
  totalCount: number;
};

export type GetDoctorListResponse = {
  isSuccess: boolean;
  message: string;
  resultCode: string;
  errors: string | null;
  data: GetDoctorListDataModel;
};

export type GetSuggestedDoctorsPayload = {
  doctorId: string;
  specialityId: string;
};

export type GetOnlineSuggestedDoctorsPayload = {
  doctorId: string;
  specialityId: string;
};

export type SuggestedDoctorDetail = {
  averageWait: number;
  doctorExperienceDate: string;
  fullName: string;
  gender: string;
  id: string;
  isInsurance: boolean;
  isTextEnabled: boolean;
  isVideoEnabled: boolean;
  isVoiceEnabled: boolean;
  latestSpecialityId: number;
  latestSpecialityName: string;
  licensedFrom: number;
  licensedTo: number;
  medicalNumber: string;
  modifiedAt: string;
  orderCount: number;
  originType: number;
  rate: number;
  rateCount: number;
  recId: number;
  showComment: boolean;
  status: number;
  imageUrl: string;
  activityStatus: DoctorActivityStatusEnum;
};

export type OnlineSuggestedDoctorDetail = {
  averageWait: number;
  doctorExperienceDate: string;
  fullName: string;
  gender: string;
  id: string;
  isInsurance: boolean;
  isTextEnabled: boolean;
  isVideoEnabled: boolean;
  isVoiceEnabled: boolean;
  latestSpecialityId: number;
  latestSpecialityName: string;
  licensedFrom: number;
  licensedTo: number;
  medicalNumber: string;
  modifiedAt: string;
  orderCount: number;
  originType: number;
  rate: number;
  rateCount: number;
  recId: number;
  showComment: boolean;
  status: number;
  imageUrl: string;
  activityStatus: DoctorActivityStatusEnum;
};

export type GetSuggestedDoctorsResponse = {
  result: SuggestedDoctorDetail[];
};

export type GetOnlineSuggestedDoctorsResponse = {
  result: OnlineSuggestedDoctorDetail[];
};

export type NotifyOnlineDoctorPayload = {
  phoneNumber: string;
  doctorId: number;
};

export type NotifyOnlineDoctorResponse = {
  isSuccess: boolean;
  message: string;
  resultCode: string;
  errors: string | null;
  data: boolean;
};

export interface DoctorServiceTariffItem {
  discountPercent: number;
  durationMinute: number;
  discountAmount: number;
  finalFee: number;
  fee: number;
}

export interface DoctorServiceTarif {
  tarifs: DoctorServiceTariffItem[];
  description: string;
  serviceType: number;
  isActive: boolean;
  title: string;
  id: ServiceIdEnum;
}

export interface DoctorServiceTarifsDataModel {
  result: DoctorServiceTarif[];
}

export type DoctorServiceTarifsResponseModel = {
  isSuccess: boolean;
  message: string;
  resultCode: string;
  errors: string | null;
  data: DoctorServiceTarifsDataModel;
};

export type DoctorActivityResponseModel = {
  isSuccess: boolean;
  message: string;
  resultCode: string;
  errors: string | null;
  data: {
    activityStatus: number;
  };
};

export interface referralReason {
  id: number;
  name: string;
}

export interface DoctorReviewItem {
  createdAt: string;
  id: number;
  doctorId: number;
  patientName: string;
  rate: number;
  comment: string;
  referralReasons?: referralReason[];
  satisfactionTypeName: string[] | null;
  dissatisfactionTypeName: string[] | null;
}

export interface DoctorReviewsData {
  result: DoctorReviewItem[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
}

export interface DoctorReviewsResponse {
  isSuccess: boolean;
  message: string;
  resultCode: string;
  errors: string | null;
  data: DoctorReviewsData;
}

export type GetOnlineDoctorListPayloadModel = {
  groupKey?: string;
  LatestSpecialityId?: string;
  pageNumber?: string;
  pageSize?: string;
  SubSpecialityId?: string;
  diseaseId?: string;
  showOnlineDoctors?: string;
  isTextEnabled?: string;
  isVoiceEnabled?: string;
  isVideoEnabled?: string;
  gender?: string;
};
export type GetOnlineDoctorListItemModel = {
  doctorId: number;
  doctorReviewsCount: number | null;
  endTime: string | null;
  groupKey: string;
  id: number;
  imageUrl: string;
  isActive: boolean;
  link: string;
  rate: number;
  startTime: string | null;
  subtitle: string;
  title: string;
};

export type GetOnlineDoctorListResponseModel = {
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  queryResult: GetOnlineDoctorListItemModel[];
};

export type OfficeCity = {
  id: number;
  name: string;
  doctorCount: number;
};

export type OfficeDataModel = {
  id: number;
  doctorName: string;
  officeName: string;
  shortAddress: string;
  address: string;
  location: {
    latitude: number;
    longitude: number;
  };
  tel: string;
};
